module.exports = __webpack_public_path__ + "img/arrow-narrow-right.fba849a9.svg";